import { useQuery } from "@tanstack/react-query";
import { getProfileData } from "./profileApis";

export const ProfileQueryKeys = {
    GET_PROFILE_DATA: 'getProfileData',
}

export const useProfileQuery = () => {
    return useQuery({
        queryKey: ProfileQueryKeys.GET_PROFILE_DATA,
        queryFn: async () => {
            const response = await getProfileData();
            return response.data.data;
        },
        staleTime: Infinity,
        cacheTime: Infinity,
        keepPreviousData: true,
    });
};